/* eslint-disable max-params */
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { ProgressIndicator } from "@cars24/turbo-web/lib/progress-indicator";
import { LinkButton } from "@cars24/turbo-web/lib/link-button";
import Arrow from "./images/arrow.svg";
import PostInspectionDiyModal from "../post-inspection-diy-modal";
import PostInspectionDiyLoanNocHoldback from "../post-inspection-diy-loan-noc-holdback";
import { InView } from "react-intersection-observer";
import { AccordionList } from "@cars24/turbo-web/lib/accordion-list";
import { Accordion } from "@cars24/turbo-web/lib/accordion";
import { Heading } from "@cars24/turbo-web/lib/heading";

const HoldBacks = ({
    showDetailsModal,
    holds = [],
    showFaqs,
    setShowFaqs,
    holdsData,
    handleFaqCall,
    faqs = [],
    showBadgeinLoanPopup = true,
    closeHoldBacks = () => {}
}) => {
    const { tokens } = useTokens();
    return (
        <React.Fragment>
            {showDetailsModal &&
            <PostInspectionDiyLoanNocHoldback
                holds={holds}
                type={showDetailsModal}
                onClose={() => closeHoldBacks()}
                showBadge={showBadgeinLoanPopup}
            />
            }
            {showFaqs &&
            <PostInspectionDiyModal
                height="480px"
                isOpen={true}
                width="520px"
                showCloseButton={true}
                onClose={() => setShowFaqs()}
            >
                <React.Fragment>
                    <div styleName="styles.heading">
                        <Heading level={NUMBER.FOUR} isBold >Frequently asked questions</Heading>
                    </div>
                    <AccordionList
                        items={faqs}
                    >
                        {(item, index, isOpen, onAccordionClick) => (
                            <Accordion
                                key={item.id}
                                title={item.question}
                                isOpen={isOpen}
                                onChange={() => {
                                    onAccordionClick({ index });
                                }}
                                shadow={false}
                                size="regular"
                            >
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.answer
                                    }}
                                />
                            </Accordion>
                        )}
                    </AccordionList>
                </React.Fragment>
            </PostInspectionDiyModal>
            }
            {holds && holds.length > NUMBER.ZERO && <div styleName="styles.containerBox">
                <div styleName="styles.container">
                    <Label level={NUMBER.THREE} fontWeight="semibold" color={tokens.text_default_text_secondary}>Your payment stages</Label>
                    {holdsData && !!holdsData.length && <ProgressIndicator
                        items={holdsData}
                        progressType="stepper"
                        type="vertical"
                    />}
                    {!!holds.length && <InView threshold={NUMBER.ONE} onChange={(inView) => handleFaqCall(inView)}>
                        <div styleName="styles.linkContainer">
                            <LinkButton
                                href=""
                                label="Frequently asked questions (FAQs)"
                                onClick={() => setShowFaqs()}
                                suffixIcon={<img src={Arrow} alt={"arrow"}/>}
                                variant="brand"
                                underLine={false}
                                preventDefaultBehaviour={true}
                            />
                        </div>
                    </InView>}
                </div>

            </div>}
        </React.Fragment>
    );
};

HoldBacks.propTypes = {
    showDetailsModal: PropTypes.bool,
    holds: PropTypes.array,
    showFaqs: PropTypes.bool,
    setShowFaqs: PropTypes.func,
    holdsData: PropTypes.object,
    handleFaqCall: PropTypes.func,
    faqs: PropTypes.faqs,
    showBadgeinLoanPopup: PropTypes.bool,
    closeHoldBacks: PropTypes.func
};
export default HoldBacks;
